import { createSelector, createSlice } from '@reduxjs/toolkit'

import type { AirportDataSource } from '~/db/airports/model/AirportInfoModel'
import type { CompanyModel } from '~/db/airports/model/CompanyModel'
import type { RunwayModel } from '~/db/airports/model/RunwayModel'
import type { CompatibleAircraftModel } from '~/types/airport-aircraft-compatibility'
import type { AirportDirectoryAirport } from '~/types/airport-directory'

export type NearbyAirport = AirportDirectoryAirport & {
    distance_km: number
}

export type AirportDetails = AirportDirectoryAirport & {
    compatibleAircraftModels?: CompatibleAircraftModel[]
    companies: CompanyModel[]
    data_sources: AirportDataSource[]
    email: string
    latitude: number
    longitude: number
    nearestAirports: NearbyAirport[]
    pcn: string
    phone: string
    runway_elevation: number
    runways: RunwayModel[]
    website: string
}

export interface AirportState {
    current: AirportDetails | null
}

const initialState: AirportState = {
    current: null,
}

export const airportSlice = createSlice({
    name: 'airport',
    initialState,
    reducers: {},
})

export default airportSlice.reducer

type AirportRootState = { airport: AirportState }

export const airportsListSelector = createSelector(
    (state: AirportRootState) => state.airport,
    (airport) => airport.current,
)
